export default __webpack_public_path__ + "static/media/present2Icon.e93ef762.svg";